<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_package_packingType') || '装箱方式'"
            prop="packingType"
          >
            <dict-select
              v-model="formData.packingType"
              url="/master/common/dict/biz"
              :body="{ dictType: 'packingType' }"
              :placeholder="
                this.$l('INDEX.tips_order_package_packingType') ||
                  '请选择装箱方式'
              "
              size="mini"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="this.$l('INDEX.order_packing_materialNo') || '物料编号'"
            ref="material"
            prop="materialNo"
          >
            <el-input clearable v-model="formData.materialNo" readonly>
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="openChoosePackage"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_packing_outBillType') || '出单类型'"
            prop="outBillType"
          >
            <dict-select
              v-model="formData.outBillType"
              url="/master/common/dict/biz"
              :body="{ dictType: 'outBillType' }"
              :placeholder="
                this.$l('INDEX.tips_order_packing_outBillType') ||
                  '请选择出单类型'
              "
              size="mini"
              style="width: 100%"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="this.$l('INDEX.order_package_materialName') || '物料名称'"
          >
            <el-input v-model="formData.materialName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="this.$l('INDEX.order_package_materialNameEn') || '英文名称'"
          >
            <el-input
              v-model="formData.materialDisplayName"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="this.$l('INDEX.order_package_materialSize') || '包装尺寸'"
          >
            <el-input v-model="formData.materialSpec" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="this.$l('INDEX.order_package_boxWeight') || '包装箱重量'"
          >
            <el-input v-model="formData.boxWeight" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="this.$l('INDEX.order_package_boxVolume') || '包装箱体积'"
          >
            <el-input v-model="formData.boxVolume" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="this.$l('order_package_orderPackingDesc') || '装箱方案描述'"
          >
            <el-input
              v-model="formData.orderPackingDesc"
              type="textarea"
              :placeholder="this.$l('tips_order_packing_orderPackingDesc')"
              :autosize="{ minRows: 4, maxRows: 6 }"
              :maxlength="250"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
      <GoodsTable
        ref="goodsTable"
        class="mt-2"
        :disabled="disabled"
        :changeOrderCode="changeOrderCode"
        :packingType="formData.packingType"
        :tableData.sync="formData.items"
      />
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
    <ChoosePackage
      :title="$l('INDEX.order_packing_choose_package_title') || '选择包装箱'"
      :visible.sync="visible"
      :changeOrderCode="changeOrderCode"
      @confirm="choosePackageConfirm"
    />
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import GoodsTable from './goods-table.vue'
import ChoosePackage from '../choose-package/dialog.vue'
const initFrom = {
  packingType: '',
  outBillType: 'storeBill',
  dispatchPort: '',
  destinationPort: '',
  materialNo: '',
  items: [],
}
export default {
  mixins: [EditLoading],
  components: { GoodsTable, ChoosePackage },
  props: {
    disabled: { type: Boolean, default: false },
    changeOrderCode: { type: String, default: '' },
    changeOrderPackingCode: { type: String, default: '' },
    isCopy: Boolean,
  },
  watch: {},
  data() {
    return {
      backDialogVisible: false,
      visible: false,
      formData: { ...initFrom },
      tableData: [],
      rules: {
        packingType: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_order_package_packingType') ||
              '请选择装箱方式',
            trigger: 'change',
          },
        ],
        outBillType: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_order_packing_outBillType') ||
              '请选择出单类型',
            trigger: 'change',
          },
        ],
        materialNo: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_order_packing_materialNo') || '请选择包装',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.changeOrderPackingCode) return
      this.$api
        .changeOrdeDemandPackingDetailApi({
          changeOrderPackingCode: this.changeOrderPackingCode,
        })
        .then((res) => {
          this.formData = res.body
          this.formData.materialSize =
            this.formData.boxLength +
            'x' +
            this.formData.boxWidth +
            'x' +
            this.formData.boxHeight +
            ' cm'
          if (this.isCopy) {
            this.formData.changeOrderPackingCode = ''
            const packingList = this.formData.items
            packingList.forEach((item) => {
              item.changeOrderPackingGoodsCode = ''
              item.orderPackingGoodsCode = ''
            })
          }
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)
      this.loadingOpen()
      this.$api
        .changeOrdeDemandPackingSaveApi({
          ...this.formData,
          changeOrderCode: this.changeOrderCode,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    openChoosePackage() {
      this.visible = true
    },
    choosePackageConfirm(data) {
      if (!data) return
      this.formData.orderPackageCode = data.orderPackageCode
      this.formData.materialNo = data.materialNo
      this.formData.materialName = data.materialName
      this.formData.materialDisplayName = data.materialDisplayName
      this.formData.materialSpec = data.materialSpec
      this.formData.boxWeight = data.boxWeight
      this.formData.boxVolume = data.boxVolume
      this.formData.isSpecify = data.isSpecify
      this.formData.scmCode = data.scmCode
    },
  },
}
</script>
